var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.33341H6.66699V1.33341C6.66699 1.1566 6.59675 0.987035 6.47173 0.86201C6.34671 0.736986 6.17714 0.666748 6.00033 0.666748C5.82351 0.666748 5.65394 0.736986 5.52892 0.86201C5.4039 0.987035 5.33366 1.1566 5.33366 1.33341V5.33341H1.33366C1.15685 5.33341 0.987279 5.40365 0.862254 5.52868C0.73723 5.6537 0.666992 5.82327 0.666992 6.00008C0.666992 6.17689 0.73723 6.34646 0.862254 6.47149C0.987279 6.59651 1.15685 6.66675 1.33366 6.66675H5.33366V10.6667C5.33366 10.8436 5.4039 11.0131 5.52892 11.1382C5.65394 11.2632 5.82351 11.3334 6.00033 11.3334C6.17714 11.3334 6.34671 11.2632 6.47173 11.1382C6.59675 11.0131 6.66699 10.8436 6.66699 10.6667V6.66675H10.667C10.8438 6.66675 11.0134 6.59651 11.1384 6.47149C11.2634 6.34646 11.3337 6.17689 11.3337 6.00008C11.3337 5.82327 11.2634 5.6537 11.1384 5.52868C11.0134 5.40365 10.8438 5.33341 10.667 5.33341Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.02b51734ef4c63420a1b712c2fe9989b.svg";
export { ForwardRef as ReactComponent };